import React, {useEffect} from 'react'
import PropTypes from 'prop-types'
import FAQ from '../faq/FAQ'
import MethodTitle from '../misc/Method-title/MethodTitle'
import {getI18nTextWithContext, getI18nTextWithParentKey} from "wipi-common/src/lib/i18n";
import InstallAppBanner from '../misc/InstallAppBanner'
import ShortCaseInfo from '../misc/ShortCaseInfo'
import BackToMethodSelectionButton from '../misc/BackToMethodSelectionButton'
import {LOG_EVENTS} from 'wipi-common/src/lib/logging/events'
import './StartAutoId.scss'
import LOG from "wipi-common/src/lib/logging/logger"
import {useI18nContext} from "../i18n/I18nContext"
import autoidIlluDark from '../../assets/illustrations/autoid-description-dark.svg'
import autoidIlluLight from '../../assets/illustrations/autoid-description-light.svg'

export default function StartAutoId({caseInfo, isMobileDevice}) {
    const context = useI18nContext()

    let availability = caseInfo.modules.identMethodSelection.methodChoice.find(method => {
        return method.method === 'autoid'
    }).footer;

    useEffect(() => {
        LOG.logInfo(LOG_EVENTS.PD_START_AUTOID)
    }, [context])

    return <>
        <div className="headless">
            <div className="col-xl-6 col-lg-6 col-md-8 col-sm-12 offset-lg-3 offset-md-2">
                <div className="row max-w-75 mx-auto">
                    <MethodTitle
                        heading={getI18nTextWithContext(context, 'startAutoId.heading')}
                        subHeading={getI18nTextWithContext(context, 'startAutoId.subHeading')}
                        info={getI18nTextWithContext(context, 'startAutoId.info')}
                        testId="hkmewo45a8i9"/>
                </div>
                <InstallAppBanner
                    caseId={caseInfo.caseId}
                    isMobileDevice={isMobileDevice}
                    availability={availability}
                    illustrationLight={autoidIlluLight}
                    illustrationDark={autoidIlluDark}/>
                <div className="mt-5">
                    <BackToMethodSelectionButton caseInfo={caseInfo} isMobileDevice={isMobileDevice}/>
                </div>
            </div>
            <ShortCaseInfo caseId={caseInfo.caseId} bcName={caseInfo.principalDisplayName}/>
        </div>
        <FAQ faq={getI18nTextWithParentKey(context, 'startAutoId.faq')}/>
    </>
}

StartAutoId.propTypes = {
    caseInfo: PropTypes.shape({
        caseId: PropTypes.string.isRequired,
        principalDisplayName: PropTypes.string.isRequired,
        modules: PropTypes.shape({
            identMethodSelection: PropTypes.shape({
                methodChoice: PropTypes.arrayOf(
                    PropTypes.shape({
                        method: PropTypes.string.isRequired,
                        footer: PropTypes.string
                    })
                ).isRequired
            }).isRequired
        }).isRequired
    }).isRequired,
    isMobileDevice: PropTypes.bool.isRequired
};